var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/WarningOutlined.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WarningOutlined = ({
  color = '#D9575E',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("path", {
    d: "M10.5 16.5C10.5 17.3284 11.1716 18 12 18C12.8284 18 13.5 17.3284 13.5 16.5C13.5 15.6716 12.8284 15 12 15C11.1716 15 10.5 15.6716 10.5 16.5ZM10.9337 12.0712C10.971 12.5946 11.4065 13 11.9311 13H12.0689C12.5935 13 13.029 12.5946 13.0663 12.0712L13.4235 7.07125C13.4648 6.49238 13.0064 6 12.426 6H11.574C10.9936 6 10.5352 6.49238 10.5765 7.07125L10.9337 12.0712Z",
    fill: color
  }), /*#__PURE__*/_jsx("path", {
    d: "M12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22ZM12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4Z",
    fill: color
  })]
});